import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ScrBaseComponent } from "../../base.component";
import { Address, AddressBookService } from "../../../services/address-book.service";
import { handleEnterKeyPress } from "src/app/shared/common-events";
import { ConfigService } from "src/app/services/config.service";

@Component({
  selector: 'app-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss']
})
export class AddressBookComponent extends ScrBaseComponent implements OnInit {

  show = false;
  update = false;
  selection: Address | null = null;
  address: Address = {};
  submitted = false;

  addressBook: Address[] = [];
  publicEmailDomains: string[] = [];

  @Output() addressChosen = new EventEmitter<Address>();

  @ViewChild('form') form!: NgForm;

  constructor(private addressBookService: AddressBookService, private configService: ConfigService) {
    super();
  }

  ngOnInit() {
    this.configService.getConfig().subscribe(cfg => {
      this.publicEmailDomains = cfg.publicEmailDomains;
    });
    this.fetchAddresses();
  }

  fetchAddresses(): void {
    this.addressBookService.getAddresses().subscribe(res => this.addressBook = res.addressbook);
  }

  addressText(address: Address): string {
    return [
      address.firstName + ' ' + address.lastName,
      address.address1,
      address.address2,
      address.city,
      address.state,
      address.zip,
      address.email,
      address.company
    ].filter(text => text).join(', ');
  }

  open() {
    this.clearMessages();
    this.fetchAddresses();  // they are cached so not a big deal
    this.show = true;
  }

  choose() {
    if (this.selection) {
      this.addressChosen.emit(this.selection);
    }
    this.show = false;
  }

  addAddress() {
    this.form.resetForm();
    this.submitted = false;
    this.show = false;
    this.address = {};
    this.update = true;
    this.clearMessages();
  }

  updateAddress() {
    this.submitted = false;
    this.show = false;
    this.address = Object.assign({}, this.selection);
    this.form.resetForm(this.address);

    // well, a hack this is...
    // our zipcode fields blank themselves out when the country changes.
    // we are reusing our form so the country does change when we update the address above.
    // however, in this case, we want to keep the zip code value.  Reassign after the
    // zip code field blanks itself out.
    setTimeout(() => {
      Object.assign(this.address, this.selection);
    }, 40);

    this.update = true;
    this.clearMessages();
  }

  saveAddress() {
    this.submitted = true;
    if (this.form.valid) {
      this.observe(this.addressBookService.saveAddress(this.address), {
        onSuccess: res => {
          this.update = false;
          if (this.address.addressBookId) {
            const i = this.addressBook.findIndex(address => address.addressBookId == this.address.addressBookId);
            this.addressBook[i] = res.addressBook;
            this.selection = null;
            this.displaySuccess(`Address ${this.address.label} has been successfully updated.`, true);
          } else {
            this.addressBook.push(res.addressBook);
            this.displaySuccess(`Address ${this.address.label} has been successfully added.`, true);
          }
          this.show = true;

          return false;
        },
        onError: () => {
          this.update = false;
          this.show = true;
        }
      });
    }
    else {
      // form not valid....
      this.form.form.markAllAsTouched();
      this.scrollToFirstError();
    }

  }

  deleteAddress() {
    if (this.selection != null)
      this.observe(this.addressBookService.deleteAddress(this.selection), {
        onSuccess: () => {
          this.addressBook = this.addressBook.filter(address => address.addressBookId != this.selection?.addressBookId);
          this.selection = null;
          this.displaySuccess(`Address has been successfully deleted.`, true);

          return false;
        }
      });
  }

  handleEnter(event : Event){
    handleEnterKeyPress(event);
  }

}